import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Navbar';
import Home from './Home';
import Websites from './websites';
import Products from './Products';
import ScrollToTop from './ScrollToTop'; // Adjust the path as necessary
import Contact from './Contact';
import ClientPortal from './ClientPortal';
import Orders from './Orders';
import './index.css'; // Import the CSS file
import Test from './Test';
import Menu from './Menu';
import Relief from './TampaStrong';

import History from './History';


// Layout with Navbar
const LayoutWithNavbar = ({ children }) => (
  <>
    <Navbar />
    {children}
  </>
);

// Layout without Navbar
const LayoutWithoutNavbar = ({ children }) => (
  <>
    {children}
  </>
);

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Routes with Navbar */}
        <Route path="/" element={<LayoutWithNavbar><Home /></LayoutWithNavbar>} />
        <Route path="/pricing" element={<LayoutWithNavbar><Products /></LayoutWithNavbar>} />
        <Route path="/websites" element={<LayoutWithNavbar><Websites /></LayoutWithNavbar>} />
        <Route path="/contact" element={<LayoutWithNavbar><Contact /></LayoutWithNavbar>} />
        <Route path="/portal" element={<LayoutWithNavbar><ClientPortal /></LayoutWithNavbar>} />
        <Route path="/hurricaneRelief" element={<LayoutWithNavbar><Relief /></LayoutWithNavbar>} />
        
        {/* Route without Navbar */}
        <Route path="/orders" element={<LayoutWithoutNavbar><Orders /></LayoutWithoutNavbar>} />
        <Route path="/menu" element={<LayoutWithoutNavbar><Menu /></LayoutWithoutNavbar>} />
        <Route path="/history" element={<LayoutWithoutNavbar><History /></LayoutWithoutNavbar>} />
      </Routes>
    </Router>
  );
};

export default App;
